import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import numberFormatter from '../../../common/numberFormatter';
import { GetSynevoExamCostSummaryDto } from '../../../common/spdCore/autogenerated/spdApiClient';

interface SynevoCostSummaryProps {
  examId: string;
  refresh: boolean;
}

export const SynevoCostSummary: React.FC<SynevoCostSummaryProps> = ({
  examId,
  refresh,
}) => {
  const spd = useSpdCore();
  const [summary, setSummary] = useState<GetSynevoExamCostSummaryDto | null>(
    null,
  );

  useEffect(() => {
    let isActive = true;

    spd.synevo
      .getForExamSummary(examId)
      .then(data => {
        if (isActive) {
          setSummary(data);
        }
      })
      .catch(() => {
        if (isActive) {
          setSummary(null);
        }
      });

    return () => {
      isActive = false;
    };
  }, [spd.synevo, examId, refresh]);

  if (!summary) {
    return null;
  }

  return (
    <Alert variant="info" className="mb-3">
      <div>
        Do Synevo można zlecać wyłącznie badania wynikające z czynników
        szkodliwych, o ile podstawy prawne powiązane z badaniem wymagają badań
        pomocniczych.
      </div>
      <div>
        Liczba zleconych badań Synevo: <strong>{summary.orderedCount}</strong>{' '}
        na kwotę <strong>{numberFormatter(summary.orderedAmount, true)}</strong>
        .
      </div>
      <div>
        Liczba niezleconych badań Synevo:{' '}
        <strong>{summary.notOrderedCount}</strong> na kwotę{' '}
        <strong>{numberFormatter(summary.notOrderedAmount, true)}</strong>.
      </div>
    </Alert>
  );
};
